/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React from 'react';
import { Tooltip } from '@carbon/react';
var ServicesList = function ServicesList(_ref) {
  var services = _ref.services;
  if (services) {
    return services.filter(function (service) {
      return service.service_id || service.capabilityId === 'private_worker' || service.entity;
    }).map(function (service, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: "service",
        key: i
      }, /*#__PURE__*/React.createElement(Tooltip, {
        label: service.metadata.displayName,
        enterDelayMs: 0,
        leaveDelayMs: 0,
        className: "cds--icon-tooltip"
      }, /*#__PURE__*/React.createElement("img", {
        src: service.metadata.imageUrl,
        alt: service.metadata.displayName
      })));
    });
  }
  return null;
};
export default ServicesList;